export const AIRE_APPS = ["close", "planning", "bank-rec", "recon"];
export const AIRE_ROLES = ["viewer", "preparer", "approver"];
//# sourceMappingURL=types.js.map